module.exports = __webpack_public_path__ + "img/c08_unitfishingboat_Normal_ua.0dd342c6.webp";